// This is a noop function to replace all the () => null we have in contexts and the like
export function noop() {
  return null;
}
